module.exports = __webpack_public_path__ + "img/tooltipDoc.373a7b2.png";